import { Button, Form, Input, InputNumber, Radio, Switch, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { patchPackage, postPackage } from '~/services/package'
import { IPackage } from '~/types/package'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<IPackage>
  refreshTable: () => void
}> = (props) => {
  const { data, refreshTable } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<IPackage>>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      if (!data.id) {
        postPackage(value)
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(err?.message || '操作失败，请稍后再试')
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        patchPackage(data.id, value)
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(err?.message || '操作失败，请稍后再试')
          })
          .finally(() => {
            setLoading(false)
          })
      }
    },
    [data.id, refreshTable],
  )

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={{
          status: 'ENABLED',
          order: 0,
          trial: false,
          ...data,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          label="套餐名"
          name="name"
          rules={[{ required: true, message: '请输入套餐名' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="有效期" name="validity">
          <InputNumber />
        </Form.Item>
        <Form.Item label="有效期描述" name="validityDescription">
          <Input />
        </Form.Item>
        <Form.Item label="折扣" name="discount">
          <InputNumber />
        </Form.Item>
        <Form.Item label="价格" name="price">
          <InputNumber />
        </Form.Item>
        <Form.Item label="折后价格" name="priceAfterDiscount">
          <InputNumber />
        </Form.Item>
        <Form.Item label="次数" name="count">
          <InputNumber />
        </Form.Item>
        <Form.Item label="状态" name="status">
          <Radio.Group
            options={[
              {
                label: '有效',
                value: 'ENABLED',
              },
              {
                label: '无效',
                value: 'DISABLED',
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="排序" name="order">
          <InputNumber />
        </Form.Item>
        <Form.Item label="试听卡" name="trial" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <Input />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
